import { Component, Input, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Label } from 'ng2-charts';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { ChartType, ChartDataSets, ChartOptions } from 'chart.js';

@Component({
  selector: 'fcp-section-chart',
  templateUrl: './section-chart.component.html',
  styleUrls: ['./section-chart.component.scss']
})
export class SectionChartComponent {

  @Input() public sectionChart = {
    title: 'title',
    subtitle: 'subtitle',
    description: 'description',
    footer: 'footer',
    chart: {
      barChartLabels: [] as Array<Label>,
      barChartType: '' as ChartType,
      barChartColors: [] as Array<{ backgroundColor: Array<string> }>,
      barChartLegend: false as boolean,
      barChartPlugins: [pluginDataLabels],
      barChartData: [] as Array<ChartDataSets>,
      barChartOptions: null as ChartOptions,
    }
  };

  @ViewChild('element') public elementRef: ElementRef;

  public canShow = false;

  @HostListener('window:scroll', ['$event']) public onWindowScroll(from?: any) {
    if (this.canShow === false && this.isElementVisible(this.elementRef.nativeElement)) {
      setTimeout(() => {
        this.canShow = true;
      }, 400);
    }
  }

  private isElementVisible(el: any): boolean {
    let top = el.offsetTop;
    let left = el.offsetLeft;
    const width = el.offsetWidth;
    const height = el.offsetHeight;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    return (
      top >= window.pageYOffset && left >= window.pageXOffset &&
      (top + height) <= (window.pageYOffset + window.innerHeight) &&
      (left + width) <= (window.pageXOffset + window.innerWidth)
    );
  }

}
